import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export default function FormControlLabelPlacement(props) {
  const handleChange = (e) => {
    props.onChangeType(e.target.value);
  };
  console.log(props, 'propspropsprops');
  return (
    <div className="view-start">
      <FormControl component="fieldset">
        <FormLabel className="input-title" component="legend">
          Вид старта:
        </FormLabel>
        <RadioGroup
          row
          aria-label="position"
          name="position"
          value={props.type || 'Graphics'}
          onChange={handleChange}>
          <FormControlLabel
            value="Graphics"
            control={<Radio color="primary" />}
            label="Графика"
            labelPlacement="bottom"
          />
          <FormControlLabel
            value="Chat"
            control={<Radio color="primary" />}
            label="Переписка"
            labelPlacement="bottom"
          />
          <FormControlLabel
            value="Stories"
            control={<Radio color="primary" />}
            label="Сторис"
            labelPlacement="bottom"
          />
          <FormControlLabel
            value="3D"
            control={<Radio color="primary" />}
            label="3D"
            labelPlacement="bottom"
          />
          <FormControlLabel
            value="Guide"
            control={<Radio color="primary" />}
            label="3D ХГ"
            labelPlacement="bottom"
            disabled={props.actorOpen}
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
}
